import PermissionsPage from "./page.permissions.page";
import { PermissionsProvider } from "../../../../contexts/users/permissions/permissions.user.context";

const PermissionLayout = () => {
  return (
    <PermissionsProvider>
      <PermissionsPage />
    </PermissionsProvider>
  );
};

export default PermissionLayout;
